import { render, staticRenderFns } from "./d-genres-signup-form.vue?vue&type=template&id=5ccb6633&"
import script from "./d-genres-signup-form.vue?vue&type=script&lang=js&"
export * from "./d-genres-signup-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports